



















































































import Vue from 'vue'
import { StickyPageInterface } from '@/config/interfaces'
import ParserFactory from '@/factory/ParserFactory'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'StickyPage',

  data: () => ({
    sheet: false
  }),

  methods: {
    parseContent (content: Record<string, unknown>) {
      return ParserFactory.getParser(content)
    },
    closeAndResetBg () {
      const root = document.querySelector(':root') as HTMLBodyElement
      root.style.setProperty('--app-default', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.appDefault)
      this.sheet = false
    }
  },

  computed: {
    stickyPageData (): StickyPageInterface {
      return this.$store.getters.getStickyPage
    },
    cardHeight (): string {
      return this.$vuetify.breakpoint.mdAndUp ? '80vh' : '90vh'
    },
    background (): string {
      return this.$vuetify.theme.dark ? '#00182C' : '#C4DFE9'
    }
  }
})
